import SalesGoal from "../../../classes/SalesGoal";
import { db } from "../../../boot/firebase";
import { collection, deleteDoc, doc, setDoc } from "firebase/firestore";

export const GET_SALES_GOAL = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: SalesGoal,
    path: SalesGoal.getPath(id),
    stateKey: "salesGoals",
    stateID: id,
    id,
  });
};

export const GET_SALES_GOALS = ({ dispatch }, { where, limit, pagination }) => {
  return dispatch("GET_COLLECTION", {
    converter: SalesGoal,
    path: SalesGoal.getPath(),
    stateKey: "salesGoals",
    where,
    limit,
    pagination,
  });
};

export const LISTEN_SALES_GOAL = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: SalesGoal,
    path: SalesGoal.getPath(id),
    stateKey: "salesGoals",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_SALES_GOALS = (
  { dispatch },
  { where, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: SalesGoal,
    path: SalesGoal.getPath(),
    stateKey: "salesGoals",
    where,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_SALES_GOAL = async ({ commit, state }, { id, data }) => {
  const now = new Date();
  const user = state.user;

  // Create a SalesGoal instance
  const goal = new SalesGoal(id, data);

  if (!id) {
    // Creating new - generate ID
    goal.data.created = now;
    goal.data.createdBy = user.id;

    const ref = doc(collection(db, SalesGoal.getPath()));
    goal.id = ref.id;

    await setDoc(ref, goal.toFirestore());
  } else {
    // Updating existing
    goal.data.modified = now;
    goal.data.modifiedBy = user.id;

    await setDoc(doc(db, SalesGoal.getPath(id)), goal.toFirestore());
  }

  // Update local state
  commit("SET", { stateKey: "salesGoals", stateID: goal.id, doc: goal });

  return goal;
};

export const DELETE_SALES_GOAL = async ({ commit }, id) => {
  await deleteDoc(doc(db, SalesGoal.getPath(id)));
  commit("REMOVE", { stateKey: "salesGoals", id });
};
